import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'spanGroups'
})
export class SpanGroupsPipe implements PipeTransform {

    transform(value:any, groupSize?:any):any {
        let index = 0;
        let result = value.split(' ').reduce((output, word)=> {
            if (index > 0 && index % groupSize == 0) {
                output += '<span>';
            }
            output += word+' ';
            if (index % groupSize == groupSize - 1) {
                output += '</span>';
            }
            index++;
            return output;
        }, '<span>');
        if (index % groupSize != groupSize ) {
            result += '</span>';
        }
        return result;
    }

}



// WEBPACK FOOTER //
// ./src/app/pipes/span-groups.pipe.ts